import { faMousePointer } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LuUserCheck } from "react-icons/lu";
import { Link, useLocation } from "react-router-dom";

import calculateRemainingDays from "../utils/calculateRemainingDays";
import digit_th_converter from "./../utils/digit_th_converter";
import digitConverter from "./../utils/digitConverter";
import { getCourseInfo } from "./admissionDates.js";

export default function NextBatchRegCard({ course }) {
  const location = useLocation();
  const onRegistrationPage =
    location.pathname === `/registration-${course}` ? true : false;

  const onCoursePage =
    location.pathname === `/courses/${course}` ? true : false;
  const courseInfo = getCourseInfo(course);

  const remainingDays = calculateRemainingDays(courseInfo.admissionStartDate);

  // ------
  const today = new Date();

  const admissionStart = new Date(courseInfo.admissionStartDate);
  const admissionEnd = new Date(courseInfo.admissionEndDate);
  const orientation = new Date(courseInfo.orientationDate);
  const flexible = new Date(courseInfo.flexibleAdmissionDate);

  return (
    <div className="bg-sky-100 p-5 md:p-16 rounded text-white my-36 next_batch_reg_card">
      <div className="mb-10 next_batch_reg_heading">
        <>
          <p className="text-center text-sky-900 text-3xl mb-4">
            {courseInfo.name} কোর্সের{" "}
            {digit_th_converter(courseInfo.upcomingBatch)} ব্যাচে{" "}
            {new Date() > new Date(courseInfo.flexibleAdmissionDate)
              ? "ভর্তি শেষ হয়েছে!"
              : new Date() < new Date(courseInfo.admissionStartDate)
                ? "ভর্তি শুরু হবে"
                : "ভর্তি শুরু হয়েছে!"}
          </p>

          {(remainingDays.months || remainingDays.days) && (
            <p className="text-center text-black text-2xl">
              আর মাত্র{" "}
              <span
                className={` ${remainingDays.months === 0 ? "hidden" : ""}`}
              >
                {digitConverter(remainingDays.months)} মাস{" "}
              </span>{" "}
              <span className={` ${remainingDays.days === 0 ? "hidden" : ""}`}>
                {digitConverter(remainingDays.days)} দিন{" "}
              </span>{" "}
              পর!
            </p>
          )}
        </>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-black text-xl next_batch_reg_text">
        <p className="p-3 bg-green-300 rounded">
          {today < admissionStart &&
            `ভর্তি শুরু হবে ${courseInfo.admissionStartDate}`}

          {today >= admissionStart && today <= admissionEnd && (
            <span className="flex items-center gap-5">
              ভর্তি চলছে <LuUserCheck />
            </span>
          )}

          {today > admissionEnd && today <= flexible && `এখনও ভর্তি হওয়া যাবে`}

          {today > flexible && `ভর্তি শেষ`}
        </p>
        <p className="p-3 bg-orange-300 rounded">
          ভর্তি শেষ হবে {courseInfo.admissionEndDate}{" "}
        </p>
        <p className="p-3 bg-red-300 rounded">
          ক্লাস শুরু হবে {courseInfo.orientationDate}{" "}
        </p>
        {!onCoursePage && (
          <Link to={`/courses/${course}`}>
            <p className="p-3 bg-pink-300 rounded shadow-md">
              কোর্স সম্পর্কে বিস্তারিত জানুন{" "}
              <FontAwesomeIcon
                className="text-pink-600"
                icon={faMousePointer}
                fade
              />
            </p>
          </Link>
        )}
        {!onRegistrationPage && (
          <Link to={`/registration-${course}`}>
            <p className="p-3 bg-green-300 rounded shadow-md">
              বুকিং দিন{" "}
              <FontAwesomeIcon
                className="text-green-600"
                icon={faMousePointer}
                fade
              />
            </p>
          </Link>
        )}
      </div>
    </div>
  );
}
